import { SEARCH_PARAMS } from './search-params';

// Prefixing the index routePath with an underscore so that we do not sort it alphabetically like the other routePaths.
export const ROUTE_PATHS = {
  enterprise: {
    account: {
      _index: '/enterprise/account',
      details: '/enterprise/account/details',
      monitors: {
        _index: '/enterprise/account/monitors',
        detail: '/enterprise/account/monitors/:id',
        buildDetailPath: (id: number) => `/enterprise/account/monitors/${id}`
      },
      profileSettings: '/enterprise/account/profile-settings',
      sites: '/enterprise/account/sites',
      teamMembers: '/enterprise/account/team-members',
      teamNotificationManagement: {
        _index: '/enterprise/account/team-notification-management',
        monitors: `/enterprise/account/team-notification-management?${SEARCH_PARAMS.TAB}=monitors`,
        thirdParty: `/enterprise/account/team-notification-management?${SEARCH_PARAMS.TAB}=third-party`
      }
    },
    assetType: {
      _index: '/enterprise/asset-type',
      assetTypeId: '/enterprise/asset-type/:assetTypeId'
    },
    ciboLocation: {
      locationDetail: '/enterprise/cibo-location/:ciboLocationId',
      buildLocationDetailPath: (ciboLocationId: number) => `/enterprise/cibo-location/${ciboLocationId}`
    },
    more: {
      _index: '/enterprise/more'
    },
    samplePoints: {
      alerts: {
        _index: '/enterprise/sample-points/alerts',
        newNotifications: '/enterprise/sample-points/alerts/new-notifications',
        all: '/enterprise/sample-points/alerts/all'
      },
      mapView: '/enterprise/sample-points/map-view'
    },
    sites: {
      _basePath: '/enterprise/sites/:siteId',
      ipCameraDetail: '/enterprise/sites/:siteId/security/:cameraId',
      ipCameraList: '/enterprise/sites/:siteId/security',
      // The 'Sensor' here is broader term than sample point. It includes both sample points and 3-rd party sensors.
      sensorList: '/enterprise/sites/:siteId/:menuCode',
      sensorTypes: '/enterprise/sites/:siteId/sensor-types',
      weatherStationDashboard: '/enterprise/sites/:siteId/weather/:controllerSamplePointSid/sensors'
    }
  }
};